import { connectHits } from 'react-instantsearch-dom'
import { useSelector } from 'react-redux'
import React from 'react'
import EventCard from '../cards/eventCard'
import NewsCard from '../cards/newsCard'
import DocCard from '../cards/docCard'
import SocialCard from '../cards/socialCard'
import BlogCard from '../cards/blogCard'

import trads from '../../intl/trads.json'

const Hits = ({hits, type}) => {
  const lang = useSelector(state => state.lang)

  const renderHit = (hit) => {
    switch(type) {
      case 'events':
        return <EventCard event={hit} isSmall={true} />
      case 'blog':
        return <BlogCard blog={hit} fromAlgolia={true} isSmall={true} />
      case 'document':
        return <DocCard document={hit} isSmall={true} />
      case 'press':
        return <DocCard document={hit} isSmall={true} isPressRelease={true} />
      case 'news':
        if (hit.contentType === 'news') {
          return <NewsCard news={hit} isSmall={true} />
        } else {
          return <SocialCard social={hit} isSmall={true} />
        }
      default:
        return <EventCard event={hit} isSmall={true} />
    }
  }

  return (
    <>
      {hits.length > 0 
        ? <ul className="flex flex-wrap">
            {hits.map((hit, i) => { 
              return (
                <li className="newsroom__list-item" key={hit.objectID}>
                  {renderHit(hit)}
                </li>
              ) 
            }) }
          </ul>
       : trads[lang].newsroom.noResults }
    </>
  )
}

const CustomHits = connectHits(Hits)

export default CustomHits